import Content from "./content";
import ContentItem from "./contentItem";
import CategoryList from "./categoryList";
import ChannelList from "./channelList";
import ContextList from "./contextList";
import TemplateDefinition from "./templateDefinition";
import Replaceable from "./replaceable";
import Asset from "./asset";
import AssetList from "./assetList";
import RunningOrderList from "./runningOrderList";
import RunningOrder from "./runningOrder";
import Story from "./story";
import StoryItem from "./storyItem";
import DataFields from "./dataFields";
import AxisOrderItem from "./axisOrderItem";
import AxisOrder from "./axisOrder";
import AxisDeliveryFeed from "./axisDeliveryFeed";
import AxisMap from "./axisMap";
import CustomPanel from "./customPanel";
import TimelineGraphic from "./timelineGraphic";
import FilterList from "./filterList";
import AutomationTransitionList from "./automationTransitionList";
import Snack from "./snack";
import SavedItem from "./savedItem";
import PrimeStyle from "./primeStyle";

/**
 * @module react/propTypes
 */
export default {
  Content,
  ContentItem,
  CategoryList,
  ChannelList,
  ContextList,
  TemplateDefinition,
  Replaceable,
  Asset,
  AssetList,
  RunningOrderList,
  RunningOrder,
  Story,
  StoryItem,
  DataFields,
  AxisOrderItem,
  AxisOrder,
  AxisDeliveryFeed,
  AxisMap,
  CustomPanel,
  TimelineGraphic,
  FilterList,
  AutomationTransitionList,
  Snack,
  SavedItem,
  PrimeStyle
};



// WEBPACK FOOTER //
// ./app/propTypes/index.js